import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconVolume = {
    alias: 'volume',
    defaultTitle: 'Volume',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M17 21a1 1 0 0 1-.565-.175l-6.412-4.396H5a1 1 0 0 1-1-1V8.57a1 1 0 0 1 1-1h5.023l6.412-4.396A1.001 1.001 0 0 1 18 4v16a1.001 1.001 0 0 1-1 1Z' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M6 14.43h4.333c.202 0 .399.061.566.174L16 18.102V5.9l-5.101 3.498a1.011 1.011 0 0 1-.566.175H6v4.857ZM17 21a.992.992 0 0 1-.565-.175l-6.412-4.396H5a1 1 0 0 1-1-1V8.572a1 1 0 0 1 1-1h5.023l6.412-4.397A.999.999 0 0 1 18 4v16a1.001 1.001 0 0 1-1 1Z' }))),
};
